<template>
  <div>
    <div v-for="(item, key, index) in data" :key="index">
      <details class="flex flex-col border-solid border-b border-grey-extralight">
        <summary class="flex flex-row text-grey h-12 bg-grey-lightest px-4 cursor-pointer">
          <div class="text-xs self-center mx-5 text-grey-dark pointer-none">{{key ? key : '-'}}</div>
          <div class="flex flex-row mx-auto items-baseline self-center"> 
            <div class="-ml-24 text-xs text-grey-dark ">APPOINTMENTS</div>
            <div class="text-l font-semibold text-grey-darkest">&nbsp;&nbsp;{{item.length}}</div>
          </div>
        </summary>
        <div class="flex flex-col"> 
          <!--START-Header-->
          <div class="grid_container bg-grey-extralight">
            <div class="item_header">Apt. Time</div>
            <div class="item_header">Patient ID</div>
            <div class="item_header">Patient Email</div>
            <div class="item_header">Patient Name</div>
            <div class="item_header">Mobile Number</div>
            <div v-if="!['externalAdmin', 'specialistDoctor'].includes(role)" class="item_header">Requested for</div>
            <div class="item_header">Program Name</div>
            <div v-if="['externalAdmin', 'specialistDoctor'].includes(role)" class="item_header">Mode</div>
            <div class="item_header">Status</div>
            <div v-if="['externalAdmin', 'specialistDoctor'].includes(role)" class="item_header">Assigned to</div>
            <div v-if="!['externalAdmin', 'specialistDoctor'].includes(role)" class="item_header">Remarks</div>
            <div v-if="['externalAdmin', 'specialistDoctor'].includes(role)" class="item_header">Consult type</div>
            <div class="item_header">Actions</div>
          </div>
          <!--END-Header-->

          <div class="grid_container" v-for="(row,index) in item" :key="index">
            <!-- Removing reschedule funtionality from Doctor Dashboard -> @click="openRescheduleModal(row)" -->
            <div class="item">{{row.date_of_appointment ? row.date_of_appointment : '-'}}</div>
            <div class="item">{{row.ek_id}}</div>
            <div class="item">{{row.email}}</div>
            <div class="item">{{row.name}}</div>
            <div class="item">{{row.mobile_number}}</div>
            <div v-if="!['externalAdmin', 'specialistDoctor'].includes(role)" class="item">{{row.service_requested}}</div>
            <div class="item">
              {{ row.program ? row.program : 'NA' }}
              <div v-if="row.program && row.service_type">
                {{ `(${row.service_type} consultation)` }}
              </div>
            </div>
            <div v-if="['externalAdmin', 'specialistDoctor'].includes(role)" class="item flex flex-col">
              <div class="item">{{row.service_mode}}</div> 
              <div class="flex">
                <a v-if="role === 'specialistDoctor' && row.service_mode === 'Video' && row.meeting_link && menu === 0"
                  :href="disableJoinButton(row.appointment_time) ? null : row.meeting_link" 
                  class="text-xs font-semibold"
                  v-bind:class="[disableJoinButton(row.appointment_time) ? 'text-grey cursor-pointer' : 'text-blue cursor-pointer hover:underline']"
                  target="_blank"
                  @click="handleMeetingLinkClick(row)"
                  rel="noopener noreferrer">
                  Join meet link
                </a>
                <img v-if="role === 'specialistDoctor' && row.service_mode === 'Video' && row.meeting_link && menu === 0" title="Copy meeting link" src="../../assets/copy.svg" class="cursor-pointer ml-2 h-3 w-3" alt="copy" @click="copyLinkHandler(row)">
              </div>
            </div>
            <div>
              <div v-if="role === 'externalAdmin'" class="item">{{ row.status }}</div>
              <div v-else class="item">
                <select name="status" placeholder="status" @change="statusChanged(row.status, row.id)" class="-mt-4" v-model="row.status">
                  <option v-if="menu === 0" value="scheduled">Scheduled</option>
                  <option v-if="menu === 1 || (role !== 'specialistDoctor' && menu === 0)" value="completed">Completed</option>
                  <!-- <option v-if="role !== 'specialistDoctor' && menu === 2" value="no_response">One Failed Attempt</option> -->
                  <option v-if="menu === 0 || menu === 3" value="incomplete">Incomplete</option>
                  <option v-if="menu === 4 || (role !== 'specialistDoctor' && menu === 0)" value="rejected">Rejected</option>
                  <option v-if="menu === 5" value="received">Received</option>
                </select>
              </div>
            </div>
            <div v-if="['externalAdmin', 'specialistDoctor'].includes(role)">
              <div v-if="row.consult_type === 'Priority' && role === 'externalAdmin' && menu === 6" @click="toggleModal(row)" class="item font-semibold cursor-pointer" style="color: #0951E1">Assign Doctor</div>
              <div v-else class="item" style="color: #00A04F">{{ row.assigned_doctor }}</div>
            </div>
            <div v-if="!['externalAdmin', 'specialistDoctor'].includes(role)" class="item flex flex-row">
              <!--remark preview-->
              <i id="remark_preview_icon" class="fas fa-eye text-blue cursor-pointer">
                <div id="remark_preview" class="relative">
                  <!--Remark tip triangle-->
                  <div class="absolute -mt-1">
                    <i class="fas fa-caret-up text-xl text-grey-lighter"></i>
                  </div>
                  <!--Remark box-->
                  <div class="absolute flex flex-shrink pin-r mt-2 -mr-10 bg-grey-lighter px-3 py-2 rounded overflow-y-auto" style="width: 300px;">
                    <!--Remark text-->   
                    <div v-if="row.comments == null || row.comments == ''" id="remark_preview_text" class="text-black text-xs font-sans leading-tight" style="word-break: break-all;">No Remarks Added</div>
                    <div v-else id="remark_preview_text" class="text-black text-xs font-sans leading-tight" style="word-break: break-all;">{{row.comments}}</div>
                  </div>
                </div>
              </i>
              <span>&nbsp;&nbsp;&nbsp;&nbsp;</span>
              <!--remark edit-->
              <i v-bind:id="`remark_edit_icon${row.id}`" class="far fa-edit text-blue cursor-pointer" @click="showRemarkEdit(row.id)">
                <div v-bind:id="`remark_edit${row.id}`" class="relative" style="display: none">
                  <!--Remark tip triangle-->
                  <div class="absolute -mt-1">
                    <i class="fas fa-caret-up text-xl text-grey-lighter"></i>
                  </div>
                  <!--Remark box-->
                  <div class="absolute flex flex-col flex-shrink pin-r mt-2 -mr-10 bg-grey-lighter px-3 py-3 rounded overflow-y-auto" style="width: 300px;">
                    <!--Remark input box--> 
                    <input type="text" name="remark_input" placeholder="Enter your remark here" v-model="row.comments" class="rounded-sm text-black text-xs font-sans leading-tight outline-none py-2 px-2" style="word-break: break-all; width: auto;">
                    <div class="flex flex-row justify-end mt-3 font-sans text-xs">
                      <div class="mx-3 cursor-pointer" @click="remarkChanged(row.comments, row.id)">Save</div>
                      <div class="cursor-pointer" @click="hideRemarkEdit(row.id)">Cancel</div>
                    </div> 
                  </div>
                </div>
              </i>
            </div>
            <div v-if="['externalAdmin', 'specialistDoctor'].includes(role)" class="item">{{ row.consult_type }}</div>
            <div class="item flex justify-start" >
              <div class="item flex justify-center" v-if="role !== 'externalAdmin'">
                <button id="remark_preview_icon" v-if="menu === 0 && disableStartConsultation(row)" class="flex-no-shrink hover:shadow-md flex-no-grow px-3 bg-grey-light text-white rounded text-center py-2 items-center self-center cursor-not-allowed">
                  Start Consult
                  <div id="remark_preview" class="relative">
                  <!--Tooltip triangle-->
                  <div class="absolute mt-1">
                    <i class="fas fa-caret-up text-xl text-grey-lighter"></i>
                  </div>
                  <!--Tooltip box-->
                  <div class="absolute flex flex-shrink pin-r mt-4 mr-2 bg-grey-lighter px-3 py-2 rounded overflow-y-auto" style="width: 300px;">
                    <!--Tooltip text-->   
                    <div id="remark_preview_text" class="text-black text-xs font-sans leading-tight" style="word-break: break-all;">Consultation opens 10 min before scheduled time</div>
                  </div>
                </div>
                </button>
                <button v-if="menu === 0 && !disableStartConsultation(row)" @click="startConsultation(row)" class="flex-no-shrink hover:shadow-md flex-no-grow px-3 bg-blue text-white rounded text-center py-2 items-center self-center cursor-pointer">
                  Start Consult
                </button>
                <div v-if="menu === 1 && role !== 'specialistDoctor'" @click="openUploadDocModal(row, key)" class="db-file-upload hover:shadow-md flex-no-shrink flex-no-grow px-3 bg-blue text-white rounded text-center py-2 items-center self-center cursor-pointer">
                  Upload
                </div>
                <div v-if="menu == 2 && row.consultation_documents.length !== 0" @click="toggleUploadDialogBox(row.id)" class="flex flex-no-shrink flex-no-grow px-2 py-1 mx-1 border border-blue bg-white text-blue rounded items-center self-center relative cursor-pointer">
                  <i v-bind:id="`upload_dialog_icon${row.id}`" class="fas fa-chevron-down"></i>
                  <!--START Upload Dialog box-->
                  <div v-bind:id="`uploadDialogBox${row.id}`" class="z-10 absolute flex flex-col flex-shrink pin-r pin-t mt-6 -mr-1 bg-grey-lightest shadow-md px-3 py-3 rounded overflow-y-auto" style="width: 300px; display: none" >
                      <!--Upload File Links--> 
                      <div class="flex flex-col justify-start text-xs">
                        <div v-for="(doc,index) in row.consultation_documents" :key="index" class="ml-1 underline my-1">
                          <span @click="getDocument(doc.id)"><a href="#">{{doc.name}}</a></span>
                        </div>
                      </div> 
                  </div>
                  <!--END Upload Dialog box-->    
                </div>
              </div>
              <div v-if="role === 'externalAdmin' && menu === 0">
                <img src="../../assets/blue_pen.svg" class="cursor-pointer" alt="action" @click="toggleModal(row)">
                <img v-if="row.service_mode === 'Video' && row.meeting_link" title="Copy meeting link" src="../../assets/copy.svg" class="cursor-pointer ml-4" alt="copy" @click="copyLinkHandler(row)">
              </div>
              <div v-if="role === 'externalAdmin' && menu === 6">
                <img v-if="row.assigned_doctor" src="../../assets/blue_check_in_circle.svg" class="cursor-pointer" alt="action" @click="statusChanged('confirmed', row.id)">
                <img v-else class="cursor-pointer" src="../../assets/grey_check_in_circle.svg" alt="action" @click="showMessage('Please assign doctor first')"/>
              </div>
            </div>
          </div>

        </div>
      </details>
    </div>
    <div v-if="showModal">
      <div id="overlay" @click="closeModal" style="position: fixed; width: 100%; height: 100%; top: 0; left: 0; right: 0; bottom: 0; background-color: rgba(0,0,0,0.5); z-index: 10; cursor: pointer;"></div>
      <div v-if="showRescheduleModal" class="absolute flex flex-col bg-white shadow rounded-sm h-auto z-20" style="width: 600px; left: calc((100vw - 600px)/2); top:150px;">
          <div style="padding: 20px">
            <div style="border-bottom: 1px solid #b8c2cc; margin: 0px -20px 20px;">
              <h3 style="padding: 0px 20px 15px">Reschedule Consultation</h3>
            </div>  
            <h4 style="margin-bottom: 10px" >Date of Appointment</h4>
            <datetime type="datetime" 
              v-model="newDate" format="yyyy-MM-dd HH:mm:ss"
              @input="updateConsultationDate"
              style="margin-bottom: 20px;" 
              class="p-2 bg-white rounded-sm border border-solid 
                     border-grey-lightest text-base text-grey-darkest focus:border-blue" 
              input-style="width: 100%;"            
            />
            <h4 style="margin-bottom: 10px" >Comments</h4>
            <textarea
              v-model="text"
              @input="updateComments"
              style="width: 100%"
              class="p-2 bg-white rounded-sm border border-solid 
                     border-grey-lightest text-base text-grey-darkest focus:border-blue"      
            />
            <p 
              v-if="errorMessage" 
              class="text-red" 
              style="margin-top: 20px" 
            >{{this.errorMessage}}</p>
            <div style="margin-top: 20px">
              <button 
                @click="closeModal"
                class="flex-no-shrink flex-no-grow px-5 py-2 bg-grey 
                text-white rounded-sm j text-center items-center"
              >Cancel</button>
              <button
                @click="rescheduleConsultation"
                class="flex-no-shrink flex-no-grow ml-2 px-6 py-2 bg-blue 
                text-white rounded-sm j text-center items-center"
              >Save</button>
            </div>  
          </div>      
      </div>
      <div v-if="showUploadDocModal" class="absolute flex flex-col bg-white shadow rounded-sm h-auto z-20" style="width: 600px; left: calc((100vw - 600px)/2); top:150px;">
        <div class="flex flex-col justify-center px-4 py-4 border-b border-solid border-grey-lighter">
          <div class="flex flex-row mb-2 justify-between items-center">
            <div class="align-center text-lg text-left font-semibold py-2"> Upload Documents</div>
            <img @click="closeModal()" class="w-6 h-6 cursor-pointer" src="../../assets/close.png">
          </div>
          <label class="text-grey-darker font-light text-xs">Categories:</label>
          <div class="flex justify-start">
            <div @click="selectFileCategory('lab_report')" v-bind:class="[fileCategory === 'lab_report' ? 'bg-blue text-white' : 'bg-white text-grey-darkest border border-solid broder-grey-lightest']" class="flex px-2 py-1 m-1 ml-0 justify-center items-center cursor-pointer rounded-sm text-xs hover:shadow">Lab Report</div>
            <div @click="selectFileCategory('diet')" v-bind:class="[fileCategory === 'diet' ? 'bg-blue text-white' : 'bg-white text-grey-darkest border border-solid broder-grey-lightest']" class="flex px-2 py-1 m-1 justify-center items-center cursor-pointer rounded-sm text-xs hover:shadow">Diet Plan</div>
            <div @click="selectFileCategory('fitness')" v-bind:class="[fileCategory === 'fitness' ? 'bg-blue text-white' : 'bg-white text-grey-darkest border border-solid broder-grey-lightest']" class="flex px-2 py-1 m-1 justify-center items-center cursor-pointer rounded-sm text-xs hover:shadow">Fitness Plan</div>
            <div @click="selectFileCategory('others')" v-bind:class="[fileCategory === 'others' ? 'bg-blue text-white' : 'bg-white text-grey-darkest border border-solid broder-grey-lightest']" class="flex px-2 py-1 m-1 justify-center items-center cursor-pointer rounded-sm text-xs hover:shadow">Others</div>
          </div>
            <div class="flex my-6 justify-center"> 
              <div class="border-b border-solid w-64 h-8 text-align">
                <p v-if="selectedFiles" class="pt-3 text-sm text-grey-darkest truncate">{{selectedFiles[0].name}}</p>
                <p v-else class="pt-3 text-m truncate text-grey text-sm">Please select a file to upload</p>
              </div>
              <div class="flex">
                <div class="mx-4 items-center">
                  <div class="flex flex-column">
                    <div class="db-file-upload">
                      <div class="file">
                        <label class="file-label width:100%">
                          <input class="file-input" style="display:none" accept=".pdf, .png, .jpg, .jpeg" type="file" name="chatfile" id="file" ref="file" @change="handleFileUpload($event.target.files)">
                          <div class="hover:shadow-md self-center bg-blue p-2 px-4 rounded text-white text-xs font-light cursor-pointer">Select</div>
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          <div v-if="selectedFiles" class="buttons flex justify-center my-2">
            <div>
              <button class="hover:shadow-md self-center bg-blue p-2 rounded text-white font-light ml-2 mt-2 text-sm px-4 cursor-pointer" @click="uploadDoc()">Upload</button>
            </div>
            <div>
              <button class="hover:shadow-md self-center bg-grey p-2 rounded text-white font-light ml-2 mt-2 text-sm px-4 cursor-pointer" v-on:click="closeModal()">Cancel</button>
            </div>
          </div> 
        </div>
      </div>
    </div>
  </div>
</template>
<script src="vue-datetime.js"></script>
<script>
  import { Datetime } from 'vue-datetime'
  import appointmentRequest from '../../api/appointment_request'
  import appointments from '../../api/appointments'
  import {mapGetters} from 'vuex'
  import * as Sentry from '@sentry/vue'
  export default {
    props: ['data', 'tab', 'canReschedule'],
    data () {
      return {
        isLoading: false,
        isPaginated: true,
        isPaginationSimple: false,
        currentPage: 1,
        perPage: 10,
        showModal: false,
        newConsultationDate: undefined,
        comments: undefined,
        errorMessage: undefined,
        currentRecord: undefined,
        showRescheduleModal: false,
        fileCategory: null,
        selectedApt: null,
        selectedKey: null,
        selectedFiles: null,
        showUploadDocModal: false
      }
    },
    components: {
      datetime: Datetime
    },
    computed: {
      ...mapGetters({
        role: 'configuration/getRole'
      }),
      isEmpty: function () {
        let isEmpty = false
        if (this.data && this.data.length < 1) {
          isEmpty = true
        }
        return isEmpty
      },
      menu: function () {
        return this.tab
      }
    },
    methods: {
      copyLinkHandler (apt) {
        if (this.role === 'specialistDoctor' && this.disableJoinButton(apt.appointment_time)) {
          this.$toast.open({message: 'Meeting link will enable 10 min before appointment time', type: 'warning', position: 'top', queue: false})
          return
        }
        navigator.clipboard.writeText(apt.meeting_link).then(() => {
          this.$toast.open({message: 'Meeting link copied successfully!', type: 'success', position: 'top', queue: false})
        }).catch(() => {
          this.$toast.open({message: 'Failed to copy link', type: 'error', position: 'top', queue: false})
        })
      },
      showMessage: function (msg) {
        let message = msg || 'Meeting link will enable 10 min before appointment time'
        this.$toast.open({message: message, type: 'warning', position: 'top', queue: false})
      },
      disableJoinButton: function (dateOfAppointment) {
        const appointmentDate = new Date(dateOfAppointment)
        const currentTime = new Date()
        const timeDifference = appointmentDate.getTime() - currentTime.getTime()
        const timeDifferenceInMinutes = timeDifference / (1000 * 60)
        return timeDifferenceInMinutes > 10
      },
      disableStartConsultation: function (appointment) {
        const appointmentDate = new Date(appointment.appointment_time)
        const currentTime = new Date()
        const timeDifference = appointmentDate.getTime() - currentTime.getTime()
        const timeDifferenceInMinutes = timeDifference / (1000 * 60)
        const disabled = timeDifferenceInMinutes > 10 || !['scheduled', 'no_response'].includes(appointment.status)
        return disabled
      },
      handleMeetingLinkClick: async function (row) {
        if (this.disableJoinButton(row.appointment_time)) {
          this.showMessage()
          return
        }

        try {
          const response = await appointments.meeting_link(row.id)
          const meetingLink = response.body.meeting_link

          if (meetingLink) {
            Sentry.setUser({ id: row.ek_id })
            Sentry.captureMessage('Meeting link clicked', {
              level: 'info',
              tags: { event_name: 'meeting_link_click' },
              extra: {
                meeting_link: meetingLink,
                appointment_request_id: row.id
              }
            })

            window.open(meetingLink, '_blank')
          } else {
            this.$toast.open({
              message: 'Meeting link not available',
              type: 'error',
              position: 'top',
              queue: false
            })
          }
        } catch (error) {
          console.error('Error fetching meeting link:', error)
          this.$toast.open({
            message: 'Failed to fetch meeting link. Please try again later.',
            type: 'error',
            position: 'top',
            queue: false
          })
        }
      },
      handleFileUpload (files) {
        this.selectedFiles = files
      },
      selectFileCategory: function (category) {
        this.fileCategory = category
      },
      openUploadDocModal: function (apt, key) {
        this.selectedApt = apt
        this.selectedKey = key
        this.showModal = true
        this.showUploadDocModal = true
      },
      statusChanged: function (status, id) {
        let obj = {status: status, id: id}
        this.$emit('updateStatus', obj)
      },
      toggleModal: function (appointment) {
        this.$store.dispatch('appointmentRequest/toggleAssignModal')
        this.$store.dispatch('appointmentRequest/updateSelectedAppointment', appointment)
      },
      remarkChanged: function (remark, id) {
        this.hideRemarkEdit(id)
        this.$emit('updateRemark', {remark: remark, id: id})
      },
      selfAssign: function (id) {
        this.$emit('selfAssign', {id: id})
      },
      startConsultation: function (appointment) {
        this.$emit('startConsultation', appointment)
        this.$store.dispatch('configuration/setActiveMiniMenu', 'OfflineConsults')
      },
      uploadDoc: function () {
        if (!this.fileCategory) {
          this.$toast.open({
            message: 'Please select a document category',
            type: 'error',
            position: 'bottom-right',
            queue: false
          })
          return
        }
        this.$emit('uploadDocuments', this.selectedFiles, this.selectedApt, this.selectedKey, this.fileCategory)
        this.closeModal()
      },
      showRemarkEdit: function (id) {
        document.getElementById('remark_edit' + id).style.display = 'block'
      },
      hideRemarkEdit: function (id) {
        document.getElementById('remark_edit' + id).style.display = 'none'
        event.stopPropagation()
      },
      getDocument: function (docid) {
        this.$http.get(window.API_URL + 'doctors/medical_records/' + docid + '/download').then(response => {
          if (response.body.status === 200) {
            window.open(response.body.url, '_blank')
          } else {
            alert('Error fetching data')
          }
        }, response => {
        })
      },
      toggleUploadDialogBox: function (id) {
        if (document.getElementById('upload_dialog_icon' + id).className === 'fas fa-chevron-down') {
          document.getElementById('uploadDialogBox' + id).style.display = 'block'
          document.getElementById('upload_dialog_icon' + id).className = 'fas fa-chevron-up'
        } else if (document.getElementById('upload_dialog_icon' + id).className === 'fas fa-chevron-up') {
          document.getElementById('uploadDialogBox' + id).style.display = 'none'
          document.getElementById('upload_dialog_icon' + id).className = 'fas fa-chevron-down'
        }
      },
      openRescheduleModal: function (row) {
        if (this.canReschedule && !['externalAdmin', 'specialistDoctor'].includes(this.role)) {
          this.showModal = true
          this.showRescheduleModal = true
          this.currentRecord = row
        }
      },
      closeModal: function () {
        this.showModal = false
        this.showRescheduleModal = false
        this.showUploadDocModal = false
        this.currentRecord = undefined
        this.comments = undefined
        this.newConsultationDate = undefined
        this.fileCategory = null
        this.selectedApt = null
        this.selectedKey = null
        this.selectedFiles = null
      },
      updateComments: function () {
        this.comments = this.text
        this.errorMessage = undefined
      },
      updateConsultationDate: function () {
        this.newConsultationDate = this.newDate
        this.errorMessage = undefined
      },
      rescheduleConsultation: function () {
        let that = this
        this.errorMessage = undefined
        if (!this.newConsultationDate) {
          this.errorMessage = "Date of appointment can't be blank"
          return
        }
        if (!(this.comments && this.comments.trim())) {
          this.errorMessage = "Comments can't be blank"
          return
        }
        let body = {
          id: this.currentRecord.id,
          date_of_appointment: this.newConsultationDate,
          comments: this.comments,
          customer_id: this.currentRecord.customer_id
        }
        appointmentRequest.reschedule(body).then(response => {
          that.$emit('updateAptRequest')
          that.showModal = false
        }, response => {
        })
      }
    }
  }
</script>
<style scoped>
summary::-webkit-details-marker{
    display: none;
}
summary:focus {
    outline: none;
}
summary::before{
    border-radius: 5px;
    content:"+";
    color: #4a4a4a;
    /* font-size: 1em; */
    /* font-weight: bold; */
    margin: 13px 0px 0px -05px;
    padding: 0;
    text-align: center;
    width: 20px;
    height: 20px;
    position: relative;
    cursor: pointer;
    
}
details[open] summary::before{
    content: "-";
}
.grid_container{
  display: grid;
  border-collapse: collapse;
  padding: 10px;

  grid-template-columns: 
    minmax(180px, auto)      /* Appoitment Date & Time */
    minmax(100px, auto)       /* Patient ID */
    minmax(140px, 200px)       /* Patient Email */
    minmax(140px, 200px)      /* Patient Name */
    minmax(110px, auto)        /* Mobile Number */
    minmax(110px, auto)     /* Requested for */
    minmax(120px, auto )       /* Program Name */
    minmax(140px, auto)      /* Mode */
    minmax(120px, auto)      /* Status */
    minmax(120px, auto)      /* Assigned to */
    minmax(110px, auto)        /* Remarks */
    minmax(80px, auto)      /* Consult type */
    minmax(100px, auto);     /* Actions */

}
.item_header{
    padding: 0px;
    margin: 0px 1px 0px 1px;
    text-align: left;
    font-size: 12px;
    color: #9B9B9B;
}
.item{
    padding: 0px;
    margin: 0px 1px 0px 1px;
    text-align: left;
    font-size: 12px;
    color: #4a4a4a;
    max-width: 120px;
    word-wrap: break-word;
}

select {
    background-color: white;
    display: inline-block;
    font: inherit;
    margin: 0; 
    outline: none;
    color: inherit;
}
.triangle {
	position: relative;
	background-color: orange;
	text-align: left;
}
.triangle:before,
.triangle:after {
	content: '';
	position: absolute;
	background-color: inherit;
}
.triangle,
.triangle:before,
.triangle:after {
	width:  10em;
	height: 10em;
	border-top-right-radius: 30%;
}
.triangle {
	transform: rotate(-60deg) skewX(-30deg) scale(1,.866);
}
.triangle:before {
	transform: rotate(-135deg) skewX(-45deg) scale(1.414,.707) translate(0,-50%);
}
.triangle:after {
	transform: rotate(135deg) skewY(-45deg) scale(.707,1.414) translate(50%);
}
#remark_preview_icon > div{
    display: none;
}
#remark_preview_icon:hover > div{
    display: block;
}
</style>



// WEBPACK FOOTER //
// src/components/Appointments/AppointmentTable.vue